import React, {
  Fragment,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react"
import { Disclosure, Popover, Transition } from "@headlessui/react"
import { MenuIcon, XIcon } from "@heroicons/react/outline"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import MenuItem from "./MenuItem"
import { AcademicCapIcon } from "@heroicons/react/solid"
import {
  MsalAuthenticationTemplate,
  useAccount,
  useIsAuthenticated,
  useMsal,
} from "@azure/msal-react"
import {
  InteractionRequiredAuthError,
  InteractionStatus,
  InteractionType,
  RedirectRequest,
} from "@azure/msal-browser"
import { loginRequest } from "../../security/authConfig"
import axios from "axios"
import { MessageContext } from "../customhooks.tsx/MessageContext"
import { QueryCache, QueryClient, useMutation, useQuery } from "react-query"
import { fetchApi, patchApi, patchApiNoToast } from "../../../Utils/Api.utils"
import { ErrorComponent } from "../graphichs/ErrorComponent"
import { Loading } from "../../../Utils/Loading"
import { dialog, kurs, medlem, profil } from "./Menu"
import { GetWebRolesNav } from "./GetWebRolesNav"
import { WebRoleContext } from "../customhooks.tsx/WebRoleContext"
import { Subscriptions, WebRole } from "../../../Utils/Entities"
import LoadingData from "../graphichs/LoadingData"
import { cyanButton } from "../../../styles/tailwindClasses"

const NavBarSignedInContent = () => {
  const { instance, accounts, inProgress } = useMsal()
  const account = useAccount(accounts[0] || {})
  const [messageCount, setMessageCount] = useState(0)
  const [roles, setRoles] = useState<WebRole[]>([])
  // const webRoles = useContext(WebRoleContext)
  // const { webRoles, setWebRoles } = useContext<WebRole[]>(WebRoleContext)
  const [assignedRole, setAssignedRole] = useState<boolean>(true)
  const [showSub, setShowSub] = useState<boolean>(true)
  const [sub, setSub] = useState<Subscriptions[]>([])
  const [isLoading, setIsLoading] = useState<boolean>(true)

  const today = new Date()

  const isAuthenticated = useIsAuthenticated()
  const messageProvider = useMemo(
    () => ({ messageCount, setMessageCount }),
    [messageCount, setMessageCount]
  )
  // let navigation = {}
  const [navigation, setNavigation] = useState({
    profil: profil,
    medlem: medlem,
    kurs: kurs,
    dialog: dialog,
  })

  let profileWR = profil
  let medlemWR = medlem
  let kursWR = kurs
  let dialogWR = dialog

  useEffect(() => {
    if (account && inProgress === InteractionStatus.None) {
      const request = {
        ...loginRequest,
        account: account,
      }
      instance
        .acquireTokenSilent(request)
        .then(response => {
          const accessToken = response.accessToken
        })
        .catch(e => {
          if (e instanceof InteractionRequiredAuthError) {
            instance.acquireTokenRedirect(request)
          }
        })
    }
  }, [account, inProgress, instance])

  const userInfoQuery = useQuery(
    "userInfo",
    () =>
      fetchApi(
        process.env.GATSBY_API_URL + "/Contacts/me",
        account,
        inProgress,
        instance
      ).then(res => res.data),
    {
      onSuccess: data => {},
      onError: _error => {},
    }
  )

  const mySubInfo = useQuery(
    "mySubs",
    () =>
      fetchApi(
        `${process.env.GATSBY_API_URL}/Contacts/Subscriptions`,
        account,
        inProgress,
        instance
      ).then(res => res.data),
    {
      // enabled: !!isAuthenticated,
      onSuccess: data => {
        setSub(data)
        if (
          !data?.find(
            item =>
              item?.subscriptionType === 778380004 && item?.stateCode !== 1
          )
        )
          setShowSub(false)
      },
      onError: _error => {},
    }
  )

  const createMenu = data => {
    if (data?.length > 0) {
      setAssignedRole(true)
      if (data.find(r => r.role === 292460001)) {
        // console.log("Finner ikke tidsskrift ab")
        profileWR = profileWR.filter(
          x => x.id === 11 || x.id === 12 || x.id === 13 || x.id === 15
        )
        medlemWR = medlemWR.filter(x => x.id === 22 || x.id === 23)
      } else if (!showSub)
        profileWR = profileWR.filter(
          x => x.id === 11 || x.id === 12 || x.id === 13 || x.id === 15
        )
      // base
      if (
        !data.find(r => r.role === 292460001) &&
        !data.find(r => r.role === 292460002)
      ) {
        // tidligere medlem
        if (data.find(r => r.role === 292460003)) {
          medlemWR = medlemWR.filter(x => x.id === 21 || x.id === 22)
        } else {
          medlemWR = medlemWR.filter(x => x.id === 21)
        }
        kursWR = kursWR.filter(
          x => x.id === 31 || x.id === 32 || x.id === 33 || x.id === 35
        )
      }
      // member
      if (
        data.find(r => r.role === 292460001) &&
        !data.find(r => r.role === 292460002)
      ) {
        kursWR = kursWR.filter(
          x => x.id === 31 || x.id === 32 || x.id === 33 || x.id === 35
        )
      }
      // kursadmin
      if (
        data.find(r => r.role === 292460002) &&
        !data.find(r => r.role === 292460001)
      ) {
        if (data.find(r => r.role === 292460003)) {
          medlemWR = medlemWR.filter(x => x.id === 21 || x.id === 22)
        } else {
          medlemWR = medlemWR.filter(x => x.id === 21)
        }
      }
    } else {
      // no roles
      profileWR = profileWR.filter(x => x.id === 11)
      medlemWR = []
      kursWR = []
      dialogWR = []
      setAssignedRole(false)
    }

    setNavigation({
      profil: profileWR,
      medlem: medlemWR,
      kurs: kursWR,
      dialog: dialogWR,
    })
  }

  const getRoles = () => {
    return fetchApi(
      `${process.env.GATSBY_API_URL}/Contacts/Roles`,
      account,
      inProgress,
      instance
    ).then(res => res.data)
  }

  const webRoleInfo = useQuery("webRoleData", () => getRoles(), {
    // enabled: enableQuery,
    onSuccess: data => {
      setRoles(data)

      createMenu(data)
    },
    onError: _error => {},
  })

  const userMessagesCountQuery = useQuery(
    "userMessagesCountData",
    () =>
      fetchApi(
        process.env.GATSBY_API_URL + "/Messages/me/unreadnr",
        account,
        inProgress,
        instance
      ).then(res => res.data),
    {
      onSuccess: data => {
        setMessageCount(data)
      },
      onError: _error => {},
    }
  )

  useEffect(() => {
    setIsLoading(
      !webRoleInfo.isSuccess || !mySubInfo.isSuccess || !userInfoQuery.isSuccess
    )
  }, [webRoleInfo.isSuccess, mySubInfo.isSuccess, userInfoQuery.isSuccess])

  return isLoading ? (
    <LoadingData />
  ) : (
    <WebRoleContext.Provider value={roles}>
      <MessageContext.Provider value={messageCount}>
        <Popover className="bg-white shadow sticky top-0 z-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6">
            <div className="flex justify-between items-center py-2 navbar:justify-start navbar:space-x-10">
              <div className="flex-shrink-0 flex justify-start pt-5 lg:flex-1">
                {/* <div className="flex items-center md:ml-4"> */}
                <Link
                  to="/app"
                  // className="inline-flex items-center justify-center rounded-md border border-transparent bg-meny-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-meny-700 focus:outline-none focus:ring-2 focus:ring-meny-700 focus:ring-offset-2 sm:w-auto"
                  activeClassName="active-link"
                >
                  <span className="sr-only">NPF-ICON</span>
                  <StaticImage
                    className="block w-12 -mt-4"
                    // src="https://tailwindui.com/img/logos/workflow-mark-white.svg"
                    src="../../../images/npf-logo.jpg"
                    alt="NPF"
                  />
                </Link>
                {/* </div> */}
              </div>
              <div className="-mr-2 -my-2 navbar:hidden">
                <Popover.Button className="bg-white rounded-md p-2 inline-flex items-center justify-center text-meny-700 hover:text-meny-600 hover:bg-meny-50 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-meny-700">
                  <span className="sr-only">Open menu</span>
                  <MenuIcon className="h-6 w-6" aria-hidden="true" />
                </Popover.Button>
              </div>
              <Popover.Group as="nav" className="hidden navbar:flex space-x-5">
                {/* {} */}
                <MenuItem menuItem={navigation?.profil} name="Profil" />
                {assignedRole ? (
                  <>
                    <MenuItem menuItem={navigation?.medlem} name="Medlemskap" />

                    <MenuItem
                      menuItem={navigation?.kurs}
                      name="Kurs og Utdanning"
                    />
                    <MenuItem
                      menuItem={navigation?.dialog}
                      name="Dialog"
                      messageCount={messageCount}
                    />
                  </>
                ) : (
                  <div></div>
                )}
              </Popover.Group>

              <div className="hidden navbar:flex items-center justify-end navbar:flex-1 lg:w-0">
                <div className="hidden navbar:flex items-center justify-end navbar:flex-1 lg:w-0">
                  {isAuthenticated ? (
                    <p className="font-medium text-gray-900">
                      Hei,{" "}
                      {userInfoQuery?.data?.firstName +
                        " " +
                        userInfoQuery?.data?.lastName}
                    </p>
                  ) : null}
                </div>
                <div className="flex items-center navbar:ml-0">
                  <Link
                    to="/"
                    onClick={() => instance.logout()}
                    className={
                      " ml-4 inline-flex items-center justify-center " +
                      cyanButton
                    }
                    activeClassName="active-link"
                  >
                    Logg ut
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <Transition
            as={Fragment}
            enter="duration-200 ease-out"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="duration-100 ease-in"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <Popover.Panel
              focus
              className="absolute top-0 inset-x-0 z-10 p-2 transition transform origin-top-right navbar:hidden"
            >
              <div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 bg-white divide-y-2 divide-gray-50">
                <div className="pt-5 pb-6 px-5">
                  <div className="flex items-center justify-between">
                    <div>
                      <StaticImage
                        className="w-10"
                        src="../../../images/npf-logo.jpg"
                        alt="Workflow"
                      />
                    </div>
                    <div className="-mr-2">
                      <Popover.Button className="bg-white rounded-md p-2 inline-flex items-center justify-center text-meny-700 hover:text-meny-600 hover:bg-meny-50 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-meny-700">
                        <span className="sr-only">Close menu</span>
                        <XIcon className="h-6 w-6" aria-hidden="true" />
                      </Popover.Button>
                    </div>
                  </div>
                  <div className="mt-6">
                    <nav className="grid gap-y-8">
                      {navigation?.profil.map(item => (
                        <a
                          key={item.name}
                          href={item.href}
                          className="-m-3 p-3 flex items-center rounded-md hover:bg-meny-50"
                        >
                          <item.icon
                            className="flex-shrink-0 h-6 w-6 text-meny-700"
                            aria-hidden="true"
                          />
                          <span className="ml-3 text-base font-medium text-gray-900">
                            {item.name}
                          </span>
                        </a>
                      ))}
                      {assignedRole ? (
                        <>
                          {navigation?.medlem.map(item => (
                            <a
                              key={item.name}
                              href={item.href}
                              className="-m-3 p-3 flex items-center rounded-md hover:bg-meny-50"
                            >
                              {/* <item.icon
                          className="flex-shrink-0 h-6 w-6 text-meny-700"
                          aria-hidden="true"
                        /> */}
                              <span className="ml-3 text-base font-medium text-gray-900">
                                {item.name}
                              </span>
                            </a>
                          ))}
                          {navigation?.kurs.map(item => (
                            <a
                              key={item.name}
                              href={item.href}
                              className="-m-3 p-3 flex items-center rounded-md hover:bg-meny-50"
                            >
                              <item.icon
                                className="flex-shrink-0 h-6 w-6 text-meny-700"
                                aria-hidden="true"
                              />
                              <span className="ml-3 text-base font-medium text-gray-900">
                                {item.name}
                              </span>
                            </a>
                          ))}
                          {navigation?.dialog.map(item => (
                            <a
                              key={item.name}
                              href={item.href}
                              className="-m-3 p-3 flex items-center rounded-md hover:bg-meny-50"
                            >
                              <item.icon
                                className="flex-shrink-0 h-6 w-6 text-meny-700"
                                aria-hidden="true"
                              />
                              <span className="ml-3 text-base font-medium text-gray-900">
                                {item.name}
                              </span>
                            </a>
                          ))}
                        </>
                      ) : (
                        <></>
                      )}
                    </nav>
                  </div>
                </div>
                <div className="py-2 px-2 space-y-4">
                  {isAuthenticated
                    ? "Hei, " +
                      userInfoQuery?.data?.firstName +
                      " " +
                      userInfoQuery?.data?.lastName
                    : null}
                  <a
                    href="/"
                    onClick={() => instance.logout()}
                    className={
                      "w-full      flex items-center justify-center " +
                      cyanButton
                    }
                  >
                    Logg ut
                  </a>
                </div>
              </div>
            </Popover.Panel>
          </Transition>
        </Popover>
      </MessageContext.Provider>
    </WebRoleContext.Provider>
  )
}

function NavBarSignedIn() {
  const authRequest: RedirectRequest = {
    ...loginRequest,
  }

  return (
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      authenticationRequest={authRequest}
      errorComponent={ErrorComponent}
      loadingComponent={Loading}
    >
      <NavBarSignedInContent />
    </MsalAuthenticationTemplate>
  )
}

export default NavBarSignedIn
